<template>
    <v-app>
        <header-card-public current_page="ChangePassword"></header-card-public>
        <v-content class="bg-container">
            <v-layout fill-height row wrap>
                <!-- Left/top Side: Ads -->
                <v-flex v-if="!isMobile" xs12 sm6 class="ads-section">
                    <div class="ads-bg">
                        <public-notifications></public-notifications>
                    </div>
                </v-flex>
                <v-flex xs12 sm6 :class="welcomeSectionClass">
                    <v-layout fill-height align-center justify-center>
                        <div class="login-container">
                            <v-card  class="mx-auto login-card" max-width="550">
                                <v-form @submit.prevent="executeRecaptcha" ref="formChangePassword">
                                    <v-card-text>
                                        <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                                            {{ errorMessage }}
                                        </v-alert>
                                        <v-layout row wrap>
                                        <v-flex xs12 style="padding:0px 20px 0px 20px;">       
                                            <v-alert :value="true" color="info" icon="info" outline>
                                                Your new password must contain at least 1 lower case, 1 upper case, 1 numeric, 1 special character and at least 12 characters long.
                                            </v-alert>
                                            <v-alert :value="true" color="info" icon="info" outline>
                                                <b>Tip:</b> Use a long and memorable password, eg: MyFavoritePetIsDog!2023
                                            </v-alert>
                                            <v-alert v-if="password_the_same" :value="true" color="error" icon="error" outline>
                                                {{dbresult_description}}
                                            </v-alert>
                                            <v-alert v-if="notthesamepassword" :value="true" color="error" icon="error" outline>
                                                Input passwords are not the same.
                                            </v-alert>
                                            <br>
                                            <v-text-field 
                                                v-model="pass1" 
                                                :rules="[rules.required, rules.min, rules.strong_password]" 
                                                label="Password"
                                                hint="At least 12 characters"
                                                counter
                                                :disabled="disabled"
                                                autocomplete="new-password"
                                                :append-icon="show1 ? 'visibility_off' : 'visibility'"
                                                :type="show1 ? 'text' : 'password'"
                                                @click:append="show1 = !show1"
                                                @blur="password_the_same=false"
                                                >
                                            </v-text-field>

                                            <v-text-field 
                                                v-model="pass2" 
                                                :rules="[rules.required, rules.min, rules.strong_password]" 
                                                label="Confirm Password"
                                                hint="At least 12 characters"
                                                counter
                                                :disabled="disabled"
                                                autocomplete="new-password"
                                                :append-icon="show2 ? 'visibility_off' : 'visibility'"
                                                :type="show2 ? 'text' : 'password'"
                                                @click:append="show2 = !show2"
                                                @blur="password_the_same=false"
                                                >
                                            </v-text-field>
                                        </v-flex>
                                        </v-layout> 
                                    </v-card-text>  
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-spacer></v-spacer>
                                        <v-btn dark :color="welcomeButtonColor" type="submit" :loading="loading">Ok</v-btn>
                                        <v-btn @click="$router.go(-1)" :disabled="disabled" >Cancel</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </div>
                        <div class="footer-section caption">
                            <div class="white--text text-xs-center">&copy; Copyright 2024 SweldoNow OPC. All Rights Reserved.</div>
                            <other-legal-docs v-if="!isMobile"></other-legal-docs>
                        </div>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-content>

        <recaptcha ref="recaptcha" @verify="submitReCaptcha"></recaptcha>
        <v-dialog v-model="dialog" width="500" persistent>                 
            <v-card>
                <v-card-title primary-title>
                    <h3>Password Changed</h3>
                </v-card-title>
                <v-card-text>
                    Your password has been successfully changed. You can now proceed to log in.
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark color="#1976D2" @click="login()">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>
<script>

import '@/assets/css/public.css'
import '@/assets/css/season.css'
import userApi from '@/api/user.js'
import Recaptcha from '@/components/ReCaptcha.vue'
import auth from '@/auth/auth.js'
import commonfn from '@/common/functions.js'
import publicPages from '@/helpers/public-pages.js'

export default {
    name: 'ChangePassword',
    metaInfo: {
        title: 'Change Password',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Password change on first login or after password reset' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        Recaptcha,
        'header-card-public': () => import('@/components/Common/HeaderPublic'),
        'public-notifications': () => import('@/components/Common/PublicNotifications'),
    },
    data () {
        return {
            dialog: false,
            userId: null,
            disabled: false,       
            loading: false,
            email: '',         
            error: false,  
            errorMessage: '',
            oldPassword: '',
            pass1: '', 
            pass2: '',
            show1: false,
            show2: false,
            showOld: false,
            seasonDetails: publicPages.getSeasonDetails(),
            title: 'Preliminary report',        
            rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 12 || 'Min 12 characters',
                counter: value => value.length <= 50 || 'Max 50 characters',
                strong_password: value => {
                    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/
                    return pattern.test(value) || 'Must contain at least 1 lower case, 1 upper case, 1 numeric, 1 special character.'
                },
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                } 
            },
            recaptchaResponse: null,
            dbresult_description: null,
            password_the_same: false
        }
    },   
    methods: {
        submitReCaptcha(response) {
            this.recaptchaResponse = response
            this.changePassword()
        },       
        executeRecaptcha() {
            if ((this.$refs.formChangePassword.validate()) && (!this.notthesamepassword)) {
                this.loading = true
                this.disabled = true
                this.$refs.recaptcha.execute()
            }
        },
        login() {
            const logoutData = {
                userId: this.$store.state.userId,
                logoutCode: "change_password",
                logoutMessage: "Change Password",
            }
            auth.logout(logoutData)
            this.dialog = false
            this.$router.push('/Login')
        },
        clear() {
            this.$refs.formChangePassword.reset()
            this.loading = false
            this.error = false
        },
        async changePassword() {
            this.error = false
            try {
                if ((this.$refs.formChangePassword.validate()) && (!this.notthesamepassword)) {
                    this.loading = true
                    this.disabled = true
                
                const response = await userApi.changePassword(this.userId, this.pass1, this.recaptchaResponse)
                
                if (response && response.status == 200) {     
                    this.dbresult_description = commonfn.validateDBResponse(response.data)
                    if (this.dbresult_description=='') {
                        this.clear() 
                        this.dialog = true  
                    }
                    else
                    {
                        this.password_the_same = true
                        this.loading = false
                        this.disabled = false
                    }  
                }
            }
            }catch(error){
                this.error = true
                this.errorMessage = error
                this.loading = false
                this.disabled = false
            }
        }
    },
    mounted() {
        this.userId = this.$store.state.userId
        if (!this.userId) 
            this.$router.push('/Home') //prevent from manually accessing change password page
        this.$refs.formChangePassword.reset()
    },
    computed: {
        notthesamepassword: function() {
            if (this.pass1 && this.pass2)
                return this.pass1!=this.pass2
        },
        isMobile() {
            return window.innerWidth < 600
        },
        welcomeSectionClass() {
            return this.isMobile ? this.seasonDetails.classNameMobile : this.seasonDetails.className
        },
        welcomeButtonColor() {
            return this.seasonDetails.buttonColor
        }
    },
    created() {}
}
</script>
